import React from "react";
import { ExternalLink, Plane, Mountain, Globe2, Star } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";

export default function NicaraguaTaxiCTA() {
  const { t } = useI18n();
  return (
    <section
      data-testid="nica-taxi-cta"
      className="relative overflow-hidden rounded-3xl text-white shadow-xl"
      style={{
        background:
          "radial-gradient(140% 100% at 0% 0%, #2a72d2 0%, #1b3b6f 55%, #0f244a 100%)",
      }}
    >
      <div className="grid grid-cols-1 sm:grid-cols-5 gap-6 items-center p-6 sm:p-8">
        <div className="sm:col-span-3">
          <p className="eyebrow" style={{ color: "#FBBF24" }}>
            {t("taxi_eyebrow")}
          </p>
          <h3
            className="mt-1 text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-white"
            style={{ fontFamily: "Outfit", textShadow: "0 2px 16px rgba(0,0,0,0.35)" }}
          >
            {t("taxi_headline")}
          </h3>
          <p className="mt-2 text-sm sm:text-base text-white/90 max-w-xl">
            {t("taxi_body")}
          </p>
          <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-xs sm:text-sm text-white/95">
            <li className="inline-flex items-center gap-1.5"><Plane className="w-4 h-4 text-amber-300" /> {t("taxi_f1")}</li>
            <li className="inline-flex items-center gap-1.5"><Mountain className="w-4 h-4 text-amber-300" /> {t("taxi_f2")}</li>
            <li className="inline-flex items-center gap-1.5"><Globe2 className="w-4 h-4 text-amber-300" /> {t("taxi_f3")}</li>
            <li className="inline-flex items-center gap-1.5"><Star className="w-4 h-4 text-amber-300" /> {t("taxi_f4")}</li>
          </ul>
          <div className="mt-5 flex flex-wrap gap-2 items-center">
            <a
              href="https://www.NicaraguaTaxi.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nica-taxi-cta-link"
              className="inline-flex items-center gap-2 pill px-5 py-2.5 bg-amber-400 text-[#0f244a] font-bold shadow-md hover:bg-amber-300 transition"
            >
              {t("taxi_cta")}
              <ExternalLink className="w-4 h-4" />
            </a>
            <span className="text-xs text-white/75">{t("taxi_caption")}</span>
          </div>
        </div>

        <div className="sm:col-span-2 flex justify-center sm:justify-end">
          <img
            src="/partners/nicaragua-taxi.png"
            alt="Nicaragua Taxi Services — Taxi & Transport across Nicaragua"
            loading="lazy"
            className="rounded-2xl w-full max-w-[300px] sm:max-w-[340px] object-contain shadow-lg"
          />
        </div>
      </div>
    </section>
  );
}
